import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {  AddressDataEntity } from "@feature/types/address.type";
import {  ShowCustomer,EmailNotifyExhibitors,CustomerBulkUploadEntity,CustomerUploadHistory } from "@feature/types/showcustomer";
import {EmailTemplateEntity,QuestionnaireFormEntity} from "@feature/types/emailtemplate.type"
import { ENV } from '@app/constants/env';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { getToken } from '@app/helpers/authProvider';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV.BASE_API_URL +ENV.MASTERS_APIURL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  incomingArgs,
  api,
  extraOptions
) => {
  let args: string | FetchArgs = incomingArgs;

  // normalize string arg to object so we can set headers
  if (typeof args === 'string') {
    args = { url: args };
  }

  try {
    const token = await getToken(); // ensure this returns a non-empty string
    if (token) {
      const headers =
        (args as FetchArgs).headers instanceof Headers
          ? (args as FetchArgs).headers
          : new Headers((args as FetchArgs).headers);

      headers.set('Authorization', `Bearer ${token}`); // use standard casing
      (args as FetchArgs).headers = headers;
    }

    const result = await rawBaseQuery(args, api, extraOptions);

    // optional: retry once if unauthorized (adjust getToken refresh logic if available)
    if (result.error && result.error.status === 401 && token) {
      // If you have a refresh flow, invoke it here then retry.
      // const refreshed = await getRefreshedToken();
      // if (refreshed) { headers.set('Authorization', `Bearer ${refreshed}`); return rawBaseQuery(args, api, extraOptions); }
    }

    return result;
  } catch {
    return { error: { status: 500, data: 'Token retrieval failed' } } as any;
  }
};


export interface ApiResponse<T> {
  success: boolean
  message?: string
  data?: T
  error?: string
}
export const showaddresssliceApi = createApi({
    reducerPath: 'showcustomersliceApi',
    baseQuery: authBaseQuery,
    tagTypes: ['showmanagement'],
    endpoints: (builder) => ({

        createaddress: builder.mutation<ApiResponse<AddressDataEntity>, { address: AddressDataEntity; userId: number }>({
            query: ({ address, userId }) => ({
                url: `Address/CreateAddress/${userId}`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: address,
            }),
            invalidatesTags: ['showmanagement'],
        }),
       
        updateaddress: builder.mutation<ApiResponse<AddressDataEntity>, { id: number; address: AddressDataEntity }>({
            query: ({ id, address }) => ({
                url: `Address/UpdateAddress/${id}`,
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: address,
            }),
            invalidatesTags: ['showmanagement'],
        }),


        getaddress: builder.query<ApiResponse<AddressDataEntity>, number>({
            query: (mstrShowId) => ({
                url: `Address/GetAddress/${mstrShowId}`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
            providesTags: ['showmanagement'],
        }),

        deleteaddress: builder.mutation<ApiResponse<null>, number>({
            query: (id) => ({
            url: `Address/DeleteAddress/${id}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            }),
            invalidatesTags: ['showmanagement'],
        }),
   getcustomersbyshow: builder.query<ApiResponse<ShowCustomer[]>, number>({
      query: (showId) => `Customer/getcustomerbyshow/${showId}`,
      providesTags: ['showmanagement'],
    }),

    deleteExhibitorsByShow: builder.mutation<ApiResponse<null>, { exhibitorsids: string; showid: number }>(
        {
            query: ({ exhibitorsids, showid }) => ({
                url: `Customer/DeleteExhibitorsByShow`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: { exhibitorsids, showid },
            }),
            invalidatesTags: ['showmanagement'],
        }
    ),

 getExhibitorsemailnotifyByShow: builder.query<ApiResponse<EmailNotifyExhibitors[]>, { showId: number; userId: number }>(
      {
        query: ({ showId, userId }) => `Customer/GetExhibitorsDDlForShow?showid=${showId}&userid=${userId}`,
        providesTags: ['showmanagement'],
      }
    ),

    getemailtemplate: builder.query<ApiResponse<EmailTemplateEntity>, number>({
                query: (showid) => ({
                    url: `EmoTemplate/GETEmailTemplatebyshow/${showid}`,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }),
                providesTags: ['showmanagement'],
            }),

     getquestionnaireform: builder.query<ApiResponse<QuestionnaireFormEntity>, number>({
                query: (showid) => ({
                    url: `EmoTemplate/GetQuestionnaireFormByShow/${showid}`,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }),
                providesTags: ['showmanagement'],
            }),

            updateimportantinfo: builder.mutation<ApiResponse<QuestionnaireFormEntity>, { showid: number; objupdateinfo: QuestionnaireFormEntity }>({
            query: ({ showid, objupdateinfo }) => ({
                url: `EmoTemplate/Updateimportantinfo/${showid}`,
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: objupdateinfo,
            }),
            invalidatesTags: ['showmanagement'],
        }),

        customerBulkUploadFile: builder.mutation<ApiResponse<string>, { file: File; showCode: string }>(
            {
                query: ({ file, showCode }) => {
                    const formData = new FormData();
                    formData.append('file', file);

                    return {
                        url: `Customer/customerbulkupload/${encodeURIComponent(showCode)}`,
                        method: 'POST',
                        body: formData,
                    };
                },
                invalidatesTags: ['showmanagement'],
            }
        ),

  Getbulkuploadhistory: builder.query<ApiResponse<CustomerUploadHistory[]>, { showcode: string }>(
      {
        query: ({ showcode }) => `Customer/GetBulkUploadHistory/${encodeURIComponent(showcode)}`,
        providesTags: ['showmanagement'],
      }
    ),


    }),
});





export const {

    useCreateaddressMutation,
    useUpdateaddressMutation,
    useGetaddressQuery,
    useDeleteaddressMutation,
    useGetcustomersbyshowQuery,
    useDeleteExhibitorsByShowMutation,
    useGetExhibitorsemailnotifyByShowQuery,
    useGetemailtemplateQuery,
    useGetquestionnaireformQuery,
    useUpdateimportantinfoMutation,
    useCustomerBulkUploadFileMutation,
    useGetbulkuploadhistoryQuery

} = showaddresssliceApi;
